import { Subscribable, Subscription } from '@benzinga/subscribable';
import { SafePromise } from '@benzinga/safe-await';
import { Product } from './entities';
import { ProductRequest, ProductRequestEvent } from './request';
import { Session } from '@benzinga/session';
// import { AuthenticationManager } from '../authentication';
// import { deepEqual } from '@benzinga/utils';

interface ProductChangedEvent {
  products: Product;
  type: 'product_changed';
}

export type ProductsManagerEvent = ProductRequestEvent | ProductChangedEvent;

export class ProductsManager extends Subscribable<ProductsManagerEvent> {
  private request: ProductRequest;
  private requestSubscription?: Subscription<ProductRequest>;
  // private authenticationSubscription: Subscription<AuthenticationManager>;

  constructor(session: Session) {
    super();
    this.request = new ProductRequest(session);
  }

  public static getName = () => 'benzinga-products';

  public getProduct = async (productName: string): SafePromise<Product> => {
    return await this.request.getProduct(productName);
  };

  protected onFirstSubscription(): void {
    this.requestSubscription = this.request.listen(event => this.dispatch(event));
  }

  protected onZeroSubscriptions(): void {
    this.requestSubscription?.unsubscribe();
  }
}
